<template>
  <div class="cont">
    <div class="cont-w">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
    .cont
        height: 420px
        //margin-top:-130px 
        background:url('../../../assets/banerbg.jpg') no-repeat top center
        .cont-w
          width: 1000px
          margin: 0 auto
</style>